import { useEffect, useState } from 'react';

import type { TimerReturnValue } from './types';

export const useTimer = (startTime = 180): TimerReturnValue => {
  const [timeLeft, setTimeLeft] = useState<number>(startTime);
  const [shouldStop, setShouldStop] = useState<boolean>(true);

  const start = () => setShouldStop(false);
  const stop = () => setShouldStop(true);
  const restart = () => {
    setTimeLeft(startTime);
    setShouldStop(false);
  };

  useEffect(() => {
    start();
    return stop;
  }, []);

  useEffect(() => {
    const interval = setTimeout(() => {
      if (!shouldStop) {
        setTimeLeft(timeLeft => timeLeft - 1);
      }
    }, 1000);

    return () => {
      clearTimeout(interval);
    };
  }, [timeLeft, shouldStop]);

  return { restart, seconds: timeLeft, setTimeLeft, shouldStop, start, stop };
};
